// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__fDxa0","productName":"Table_productName__282Ps"};